export default __webpack_public_path__ + "static/media/logo-carabao-express.5b03810d.png";